export function getCouponMessage(isDownload?: boolean, message?: string) {
  if (isDownload) {
    return '쿠폰이 발급되었습니다.';
  }
  if (message) {
    return message;
  }
  return '일시적인 오류가 발생했습니다. 잠시 후 다시 시도해주세요.';
}

/** 쿠폰 적용 디바이스(채널) 코드 → 화면 표시 라벨 */
const COUPON_CHANNEL_LABEL: Record<string, string> = {
  APP_MO: '모바일 전용',
  MO: '모바일 전용',
  MO_PC: '모바일/PC',
  APP_MO_PC: '모바일/PC',
  APP_PC: '모바일/PC',
  PC: 'PC 전용',
  APP: '앱전용',
};

export function getCouponChannel(channel: string): string {
  return COUPON_CHANNEL_LABEL[channel] ?? channel;
}
